<template>
    <div class="content" v-if="user && user.user">
      <h1>Personal Projects Secure</h1>
      <p><a href="https://skillvolution.wordpress.com/wp-admin/edit.php">has a load of posts i started about 15</a></p>
      <p>D:\Clients\www.copy-paste-code.com1\BlogEngine - load of coding blog posts i started. about 20</p>
      <p>C:\Users\chris\OneDrive\Pictures\Wedding - wedding photos</p>
    </div>
</template>

<script>
  import { useAuthStore, fetchWithOrWithoutAuth, fetchWithAuth, refreshToken, startTokenRefreshTimer } from 'shared-vue'
  import { mapState } from 'pinia';
  export default {
    components: {
    },
    data() {
      return {
        isAuthenticated: false,
      };
    },

    computed: {
      ...mapState(useAuthStore, ['user']),
      isAdmin() {
        return this.user?.roles?.includes("Admin");
      }    
    },
    methods: {

    },
    created() {
      if (localStorage.getItem("authToken")) {
        this.isAuthenticated = true;
      }
    }
  };
</script>
